import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Close: FC<ISvG> = ({
  fill = "#FFF",
  width = "14",
  height = "15",
  strokeWidth,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 15"
    >
      <g>
        <g>
          <path
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeMiterlimit="20"
            strokeWidth={strokeWidth ?? "1.5"}
            d="M.779.765l11.963 12.884"
          />
        </g>
        <g>
          <path
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeMiterlimit="20"
            strokeWidth={strokeWidth ?? "1.5"}
            d="M.779 13.649L12.742.765"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Close);
